import axios from 'axios';
import LoggerFactory from './Logger/LoggerFactory';

async function fetchJSON(url: string): Promise<JSON> {
  const logger = LoggerFactory.get('fetchJSON');

  let jsonString = null;
  try {
    const response = await axios.request({
      url,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });

    jsonString = response.data;
  } catch (e) {
    logger.error(e);
    throw new Error('Could not fetch JSON from url.');
  }

  let json = null;
  try {
    json = JSON.parse(JSON.stringify(jsonString));
  } catch (e) {
    logger.error(jsonString);
    logger.error(e);
    throw new Error('Could parse fetched JSON.');
  }

  return json;
}

export default fetchJSON;
